import { render, staticRenderFns } from "./HeaderSearchResults.vue?vue&type=template&id=54ada64f&"
import script from "./HeaderSearchResults.vue?vue&type=script&lang=js&"
export * from "./HeaderSearchResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports